import React, {useContext} from 'react';

const SitemapContext = React.createContext({
    sitemap: {},
    setSitemap: () => {},
});

const useSitemap = () => useContext(SitemapContext);

export {useSitemap};
export default SitemapContext;
